export const GET_PRODUCT = '/product/info';
export const GET_ADDRESS_SEARCH = '/address/search';
export const GET_ADDRESS_DETAIL = '/address/detail';
export const POST_FORM_SUBMIT = '/form/submit';
